export enum CARDIAC_PROTOCOLS {
  GENERAL = '01',
  MEN = '02',
  ACTIVE_MEN = '03',
  SEDENTARY_MEN = '04',
  WOMEN = '05',
  SEDENTARY_INDIVIDUALS = '06',
}
